import React from 'react';

export const pendingEvents = [];

export default class F7Listener extends React.PureComponent {
  componentDidMount() {
    this.$f7ready(app => {
      pendingEvents.map(intent => intent(app));
      F7Listener.clearPendingEvents();

      document.removeEventListener('f7', collectEvents, true);
      document.addEventListener('f7', function(event) {
        const { intent } = event.detail;

        if (intent)
          intent(app);
      }, true);
    });
  }

  render() {
    return null;
  }
}

F7Listener.clearPendingEvents = function clearPendingEvents() {
  pendingEvents.splice(0);
};

function collectEvents(event) {
  const { intent } = event.detail;
  if (intent)
    pendingEvents.push(intent);
}

document.addEventListener('f7', collectEvents, true);
